import React from "react";
import { HashLink } from "react-router-hash-link";
import { getLang } from "../../features/app/appSlice";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Logo from "../../components/Logo/Logo";

const qrFollowUs = require("../../assets/media/logo/wechat-official-qrcode.jpg");
const qrChatToUs = require("../../assets/media/logo/qrcode-wechat.png");
const qrWhatsapp = require("../../assets/media/logo/qrcode-whatsapp.png");
const nvfoLogo = require("../../assets/media/logo/nvfo-logo-white.png");
const iaa = require("../../assets/media/logo/iaa-logo-white.png");
const ilpa = require("../../assets/media/logo/ilpa-logo-white.png");
const ciol = require("../../assets/media/logo/ciol-logo-white.png");

function Footer(props: any) {
  const lang = useSelector(getLang);

  return (
    <footer
      className={`mt-auto pt-16 pb-10 px-10 text-white bg-secondary-dark border-t border-gold/25 flex flex-col gap-16`}
    >
      <div className="max-width-centered w-full mx-auto grid grid-cols-1 md:grid-cols-[1.3fr_1fr_1fr_1fr_1.1fr] gap-12">
        <div>
          <img
            className="h-9 mb-8"
            src={nvfoLogo}
            alt="New Vision Family Office"
          />
          <div className="flex items-center gap-3 text-sm text-white/60 tracking-[0.1em]">
            <span className="h-[1px] w-6 bg-gold" />
            <p>国际视野 本地专识</p>
          </div>
          <p className="font-thin text-white/50 text-xs mt-1.5 tracking-[0.2em] uppercase">
            Global Vision · Local Expertise
          </p>
          <ul className="flex gap-3 h-12 mt-8 opacity-80">
            <li>
              <img className="h-full" src={iaa} alt="IAA" />
            </li>
            <li>
              <img className="h-full" src={ilpa} alt="ILPA" />
            </li>
            <li>
              <img className="h-full" src={ciol} alt="CIOL" />
            </li>
          </ul>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-xs tracking-[0.15em] uppercase text-gold-light mb-1">
            身份规划
          </p>
          <HashLink
            to="/program#residence"
            className="text-white/70 hover:text-white transition-colors"
          >
            居留项目
          </HashLink>
          <HashLink
            to="/program#passport"
            className="text-white/70 hover:text-white transition-colors"
          >
            护照项目
          </HashLink>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-xs tracking-[0.15em] uppercase text-gold-light mb-1">
            财富规划
          </p>
          <HashLink
            to="/wealth#tax"
            className="text-white/70 hover:text-white transition-colors"
          >
            税务规划
          </HashLink>
          <HashLink
            to="/wealth#company"
            className="text-white/70 hover:text-white transition-colors"
          >
            公司服务
          </HashLink>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-xs tracking-[0.15em] uppercase text-gold-light mb-1">
            传承规划
          </p>
          <HashLink
            to="/legacy#trust"
            className="text-white/70 hover:text-white transition-colors"
          >
            家族信托
          </HashLink>
          <HashLink
            to="/legacy#education"
            className="text-white/70 hover:text-white transition-colors"
          >
            教育规划
          </HashLink>
          <HashLink
            to="/legacy#charity"
            className="text-white/70 hover:text-white transition-colors"
          >
            慈善公益
          </HashLink>
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-xs tracking-[0.15em] uppercase text-gold-light mb-1">
            联系我们
          </p>
          <a
            href="tel:+447497999999"
            className="text-white/70 hover:text-white transition-colors"
          >
            +44 (0) 20 3907 4025
          </a>
          <a
            href="mailto:fo@newvgroup.com"
            className="text-white/70 hover:text-white transition-colors"
          >
            fo@newvgroup.com
          </a>
          <p className="text-white/50 text-sm leading-relaxed mt-1">
            16 Berkeley Street, Mayfair
            <br />
            London, W1J 8DZ
            <br />
            United Kingdom
          </p>
          <div className="flex items-start gap-6 mt-4">
            <div className="flex flex-col items-start gap-1">
              <img
                className="h-16 w-auto max-w-none"
                src={qrChatToUs}
                alt="微信咨询二维码"
                style={{ filter: "invert(1)", mixBlendMode: "screen" }}
              />
              <p className="text-xs text-white/50">微信咨询</p>
            </div>
            <div className="flex flex-col items-start gap-1">
              <img
                className="h-16 w-auto max-w-none"
                src={qrWhatsapp}
                alt="WhatsApp咨询二维码"
                style={{ filter: "invert(1)", mixBlendMode: "screen" }}
              />
              <p className="text-xs text-white/50">WhatsApp咨询</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-width-centered w-full mx-auto flex flex-col items-center">
        <ul className="flex w-full gap-6 pb-6 mb-6 text-white/50 border-b border-white/10 justify-center">
          <li>
            <NavLink
              to="/policies/terms"
              target="_blank"
              className="hover:text-gold-light transition-colors"
            >
              Terms of use
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/policies/privacy"
              target="_blank"
              className="hover:text-gold-light transition-colors"
            >
              Privacy Policy
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/policies/cookies"
              target="_blank"
              className="hover:text-gold-light transition-colors"
            >
              Cookie Policy
            </NavLink>
          </li>
        </ul>
        <p className="text-center text-xs text-white/30 max-w-[500px]">
          &copy;{new Date().getFullYear()} New Vision Family Office. New Vision
          Family Office 是 New Vision International Group Limited
          新愿景国际集团有限公司的商业名称，注册于英格兰及威尔士，公司编号为13029696。
        </p>
      </div>
    </footer>
  );
}

export default Footer;
